<app-admin-notifications-component />
